
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class FknnTable extends Vue {
    //疯狂牛牛
    table = {
        data: [],
        column: [
            {
                key: 'uid',
                title: '玩家ID',
                align: 'center',
                render: (h, params) => {
                    let str = bulidUid(params.row.uid)
                    return h('div', [
                        h('p', str),
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red'
                                }
                            },
                            String(params.row.uid).indexOf(String(params.row.user_id)) > -1 ? '(查询玩家)' : ''
                        )
                    ])
                }
            },
            {
                key: 'C',
                title: '手牌详情',
                align: 'center',
                width: 200,
                render: (h, params) => {
                    let strzo = params.row.data.C || []
                    return h('div', {
                        style: {
                            marginTop: '5PX'
                        },
                        domProps: {
                            innerHTML: strzo.map((x) => {
                                return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                            })
                        }
                    })
                }
            },
            {
                key: 'Rank',
                title: '大小',
                align: 'center',
                render: (h, params) => {
                    return h('span', '第' + params.row.data.Rank + '大')
                }
            },
            {
                key: 'Bet',
                title: '投注金额',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.Bet))
                }
            },
            {
                key: 'RealAWard',
                title: '变动金额',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.RealAWard))
                }
            },
            {
                key: 'PercentPoin',
                title: '税收金额',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.PercentPoin))
                }
            }
        ]
    }
    getListData() {
        let obj2 = JSON.parse(this.listdata[0].opt_detail).users
        let arr2: any = []
        for (let i in obj2) {
            let Object = {
                user_id: this.listdata[0].user_id,
                uid: i,
                data: obj2[i]
            }
            arr2.push(Object)
        }
        arr2.sort((a, b) => {
            return a.data.Rank - b.data.Rank
        })
        return arr2
    }
    @Prop()
    listdata
}
